import { ButtonERP } from "@finanedi.es/storybook"
import { faArrowLeft } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ESTADO_CUENTA } from "api/Types/EstadoCuenta"
import { DEFAULT_BANK_LOGO_URL } from "features/Tesoreria/pages/Bancos/constants"
import { reverseBlockSplit } from "utils/reverseBlockSplit"
import { usePropuestasConciliacionHeader } from "./hooks"
import { IPropuestasConciliacionHeaderProps } from "./interfaces"

export const PropuestasConciliacionHeader = ({
  cuentaId,
}: IPropuestasConciliacionHeaderProps) => {
  const { cuentaBancariaById, handleBack } = usePropuestasConciliacionHeader({
    cuentaId,
  })

  return (
    <div className='tw-flex tw-flex-col xl:tw-flex-row xl:tw-justify-between tw-px-4 tw-pt-4 tw-pb-3 tw-bg-white tw-shadow-3xl tw-mb-1 xl:tw-px-8'>
      <div className='tw-pr-2 tw-flex tw-items-center tw-gap-x-4'>
        <ButtonERP
          customize={{
            type: "white",
            size: "md",
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={handleBack}
        />
        <img
          className={`${
            cuentaBancariaById?.logo
              ? "tw-h-11 tw-scale-125"
              : "tw-w-11 tw-h-11"
          }`}
          src={cuentaBancariaById?.logo || DEFAULT_BANK_LOGO_URL}
          alt=''
        />

        <div className='tw-flex tw-flex-col tw-items-center tw-whitespace-nowrap lg:tw-flex-row tw-gap-2'>
          <span className='tw-w-full tw-items-center tw-text-lg tw-font-medium tw-text-left'>
            {cuentaBancariaById?.nombre
              ? `${cuentaBancariaById.nombre} - ${cuentaBancariaById?.entidadBancaria?.nombre}`
              : cuentaBancariaById?.entidadBancaria?.nombre}
          </span>
          <span className='tw-w-full tw-items-center tw-text-base tw-text-left tw-font-medium tw-text-text-50'>
            {reverseBlockSplit(cuentaBancariaById?.iban || "", 4)}
            {cuentaBancariaById?.estado === ESTADO_CUENTA?.VALIDADA ? (
              <FontAwesomeIcon
                icon={["fal", "check-circle"]}
                className='ml-2 tw-text-secondary'
              />
            ) : null}
          </span>
        </div>
      </div>
    </div>
  )
}
